



























































import {
    Component, Model, Vue, Watch,
} from 'vue-property-decorator';
import { concat } from 'lodash';
import FileUpload from 'vue-upload-component';
import InsertPhotoDialog from '@/components/global/InsertPhotoDialog/InsertPhotoDialog.vue';
import { ProductTemplate } from '@/assets/interface/Product';
import UploadedImageItem from './UploadedImageItem.vue';

@Component({
    components: {
        FileUpload,
        UploadedImageItem,
        InsertPhotoDialog,
    },
})
export default class InsertImage extends Vue {
    @Model('change', { type: Object }) public product!: ProductTemplate;

    public showInsertPhotoDialog = false;

    public insertImageEvent(action: string, label: any) {
        this.$ga.event('InsertImage', 'click', action, label);
    }

    public onInsertPhotoClick() {
        this.insertImageEvent('Click insert photo', 'Insert photo');
        this.showInsertPhotoDialog = true;
    }

    public removeImg(index: number) {
        this.insertImageEvent('Click remove image', '- Icon');
        this.product.images.splice(index, 1);
    }

    public onInsert(urls: string[]) {
        const extra = this.product.images.length + urls.length - this.$store.getters.getMaxImage;
        if (extra > 0) {
            this.product.images.splice(this.product.images.length - extra, extra);
        }
        this.product.images = concat(urls, this.product.images);
    }
}
